module.exports = function getResource(label, vars = []) {
    const resources = {
        firstName: 'First Name',
        lastName: 'Last name',
        emailAddress: 'Email address',
        phone: 'Phone',
        sendReminders: 'Yes, send me text message reminders about my appointment.',
        specialRequests: 'Special requests (optional)',
        specialRequestsPlaceholder: 'Help our Beauty Advisors prepare for your visit, e.g. I’m interested in trying out a new smoky eye for an upcoming event.',
        completeBooking: 'Complete Booking'
    };

    return resources[label];
};
